import { getAPIHeaders } from "../app/utils";
import { serverApi } from "../services";

export const getUsers = async (payload) => {
  try {
    const reqOpts = getAPIHeaders(payload);
    const response = await serverApi.get("users", reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const postUser = async (payload) => {
  try {
    const reqOpts = getAPIHeaders();
    const response = await serverApi.post("users", payload, reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const putUser = async ({ id, payload }) => {
  try {
    const reqOpts = getAPIHeaders({ USER_ID: id });
    const response = await serverApi.put("users", payload, reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const getUserRequests = async (payload) => {
  try {
    const reqOpts = getAPIHeaders(payload);
    const response = await serverApi.get("/requests", reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};

export const putUserRequest = async ({ id, payload }) => {
  try {
    const reqOpts = getAPIHeaders({ REQUEST_ID: id });
    const response = await serverApi.put("requests", payload, reqOpts);
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};
